import React, { useState } from "react";
import { useGetFetchNew } from "../../../data/Queries";
import { top_courses, delete_academy_course } from "../../../data/ApiEndpoints";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { Col, Container, Row } from "react-bootstrap";
import { formatDate } from "../../../utils/utilityfunc";
import CommonStructured from "../../common-components/CommonStructured";
import Modal from "react-modal";
import UpdateCourse from "./UpdateCourse";
import ManageCategory from "../academy-categories/ManageCategory";
import ViewCourse from "./ViewCourse";
import { DeleteIcon, EditIcon } from "../../../images/icons/website-icons";
import { useDispatch } from "react-redux";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { EyeIcon } from "../../../images/icons/icons";
import { convertThenFormat } from "../../common-data/Converts";

const CourseList = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(8);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isManageCategoriesOpen, setIsManageCategoriesOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modValues, setModValues] = useState({
    isModOpen: false,
    cardName: "",
  });
  const [initialValues, setInitialValues] = useState(null);

  console.log("User info data", userInfoData);

  const {
    data,
    isLoading: dataLoading,
    refetch,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "academy_courses",
    url: `${top_courses}`,
    filters: {
      limit: pageLimit,
      page: page + 1,
    },
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
    setModValues({
      isModOpen: false,
      cardName: "",
    });
  };

  const handleAddCourse = () => {
    setInitialValues(null);
    setIsModalOpen(true);
    setModValues({
      isModOpen: true,
      cardName: "add",
    });
  };

  const handleEdit = (row) => {
    setIsModalOpen(true);
    setModValues({
      isModOpen: true,
      cardName: "edit",
    });
    setInitialValues(row);
  };

  const handleManageCategories = () => {
    setIsManageCategoriesOpen(true);
    setModValues({
      isModOpen: true,
      cardName: "manageCategories",
    });
  };

  const handleView = (row) => {
    setSelectedCourse(row);
    setIsViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
    setSelectedCourse(null);
  };

  const handleDeleteCourse = async (course) => {
    if (course?.uid) {
      const handleConfirm = async () => {
        try {
          setIsLoading(true);
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_academy_course,
              queryParams: { uid: course.uid },
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Course deleted successfully!");
            refetch();
          } else {
            toast.error(response?.message || "Cannot delete course!");
          }
        } catch (error) {
          toast.error(error?.message || "Failed to delete course");
        } finally {
          setIsLoading(false);
        }
      };

      showConfirmAlert(
        handleConfirm,
        "Are you sure you want to delete this course?"
      );
    } else {
      toast.error("Course ID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "title",
      text: "Course Name",
      formatter: (cell, row) => <span className="tb-data">{row.title}</span>,
    },
    {
      dataField: "category_name",
      text: "Category",
      formatter: (cell, row) => (
        <span className="tb-data">{row.category_name}</span>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => (
        <span className="tb-data">{formatDate(row.date_added)}</span>
      ),
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (cell, row) => (
        <span className="tb-data">₹{convertThenFormat(row.price)}</span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data flexCenter">
            <span
              className={
                row?.status === "active" ? "greenColorBg" : "redColorBg"
              }
            >
              {row?.status || "NA"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "rating",
      text: "Rating",
      formatter: (cell, row) => (
        <span className="tb-data">
          {row.rating ? `${row?.rating}⭐` : "NA"}
        </span>
      ),
    },
    {
      dataField: "actions",
      text: "actions",
      formatter: (cell, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              className="actionBtn icon view"
              onClick={() => handleView(row)}
              disabled={isLoading}
            >
              <EyeIcon />
            </button>
            <button
              className="actionBtn icon edit"
              onClick={() => handleEdit(row)}
              disabled={isLoading}
            >
              <EditIcon />
            </button>
            <button
              className="actionBtn icon delete"
              onClick={() => handleDeleteCourse(row)}
              disabled={isLoading}
            >
              <DeleteIcon />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <Container className="bg-cloud-k px-50px gobal-container" fluid>
      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Academy Courses"}
            createBtnTxt={`+ Add Course`}
            createBtnTxt2={`Manage Categories`}
            onClickCreateBtn={handleAddCourse}
            onClickCreateBtn2={handleManageCategories}
          />
        </Col>
      </Row>

      {/* 
      <FilterContainer>
        <SearchFilter />
      </FilterContainer> */}

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        <PaymentLinkTable
          tableData={data?.data}
          tableColumns={tbColumns}
          userInfoData={userInfoData}
          isPage={page}
          setIsPage={(value) => setPage(value)}
          isLoading={dataLoading}
          tablePagination={data?.pagination}
          setPageLimit={setPageLimit}
          pageLimit={pageLimit}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        onHide={handleModalClose}
        ariaHideApp={false}
        contentLabel="Course Modal"
      >
        <UpdateCourse
          isEdit={modValues.cardName === "edit"}
          closeModal={handleModalClose}
          token={userInfoData?.token}
          getCourseData={refetch}
          initialValues={initialValues}
        />
      </Modal>

      <Modal
        isOpen={isManageCategoriesOpen}
        onHide={() => setIsManageCategoriesOpen(false)}
        ariaHideApp={false}
        contentLabel="Manage Categories"
      >
        <ManageCategory
          token={userInfoData?.token}
          closeModal={() => setIsManageCategoriesOpen(false)}
          initialValues={initialValues}
        />
      </Modal>

      <Modal
        isOpen={isViewModalOpen}
        onHide={() => setIsViewModalOpen(false)}
        ariaHideApp={false}
        contentLabel="View Course"
      >
        <ViewCourse course={selectedCourse} onClose={handleViewModalClose} />
      </Modal>
    </Container>
  );
};

export default CourseList;
